import React, { useCallback } from 'react';

import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Modal from 'react-bootstrap/Modal';
import Row from 'react-bootstrap/Row';

import { useCheckout } from '@src/hooks/queries/cartItems';
import { useUserInfo } from '@src/hooks/userInfo';

import LoadingElement from '@src/components/loader';

import CartContent from './../CartContent';

import './CartModal.scss';

const CartModal = (props) => {
    const {
        onClose,
        onSubmit,
        cartItemsData,
    } = props;

    const [mutateCheckout] = useCheckout();
    const user = useUserInfo();
    const agencyMdfAllocation = user.agencyMdfAllocation || 0;
    const agencyMdfUsed = Math.round(agencyMdfAllocation * 0.10 * 100) / 100;
    const agencyMdfRemaining = Math.round((agencyMdfAllocation - agencyMdfUsed) * 100) / 100;

    const handleOnSubmit = useCallback(() => {
        const cartItemIds = cartItemsData.cartItems.map((ci) => ci.id);
        mutateCheckout(cartItemIds, {
            onSuccess: (response) => {
                const id = response.data.id;
                const uuid = response.data.uuid;
                onSubmit(id, uuid);
            },
            onError: (error) => {
                // eslint-disable-next-line no-console
                console.error('Error on checkout: ', error);
            },
        });
    }, [mutateCheckout, onSubmit, cartItemsData]);

    return (
        <Modal
            show
            animation={false}
            className="cart-modal"
            onHide={onClose}
        >
            <Modal.Header closeButton />
            <Modal.Body className="cart-body">
                <Col className="p-2">
                    <Row>
                        {
                            (!cartItemsData || cartItemsData.loaded !== 'complete') && (
                                <LoadingElement style={{ transform: 'scale(0.5)' }} />
                            )
                        }
                        {
                            cartItemsData && cartItemsData.loaded === 'complete' && cartItemsData.cartItems?.length === 0 && (
                                <h3 className="w-100 text-center">No Items</h3>
                            )
                        }
                        {
                            cartItemsData && cartItemsData.loaded === 'complete' && cartItemsData.cartItems?.length > 0 && (
                                <CartContent
                                    cartItems={cartItemsData.cartItems}
                                />
                            )
                        }
                    </Row>
                    <Row>
                        <Col className="p-0 agency-info">
                            <hr />
                            <p>
                                <span className="pr-1">
                                    You can select list of customers than will receive your print collateral.
                                </span>
                                <a href="#" className="ml-link">Add Customers List</a>
                            </p>
                            <div className="mdf-remaining w-100 py-3">
                                MDF Remaining: <b>${agencyMdfRemaining}</b>
                            </div>
                            {
                                cartItemsData && cartItemsData.cartItems?.length > 0 && (
                                    <div className="start-checkout w-100 pt-3">
                                        <a
                                            href="#"
                                            className="ml-button-primary w-100"
                                            onClick={handleOnSubmit}
                                        >
                                            Start Checkout
                                        </a>
                                    </div>
                                )
                            }
                        </Col>
                    </Row>
                </Col>
            </Modal.Body>
        </Modal>
    );
};

CartModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    cartItemsData: PropTypes.object,
};

export default React.memo(CartModal);
